<template>
  <div class="filter-widget">
    <h2 class="widget-title">{{$t('other_colors')}}</h2>
    <div class="widget-listing">
      <ul class="colors">
        <li v-for="(product, key) in products" :key="key" v-if="product.meta.color">
          <router-link :to="$i18nRoute({name: 'product', params: {product: product.id}})">
            <input
                    type="radio"
                    :checked="product.id==$route.params.product"
            />
            <label :style="{backgroundColor: product.meta.color[0], border: '1px solid ' + product.meta.color[0]}" :data-color="product.meta.color[0]"></label>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ['products'],
  data () {
    return {
      selected_options: []
    }
  },
  methods: {
    set_attribute (option) {
      this.$emit('set_attribute', option, this.filter.name)
    }
  }
}
</script>
